import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: '戻る',
      changePassword: 'パスワード変更',
      copiedVaultId: 'コピーしました！',
      copyVaultID: 'Vault IDをコピーしてください',
      create: '作成',
      next: '次へ',
      notSure: '確信がもてない',
      signUp: 'サインアップ',
      submit: '提出',
      updatePassword: 'パスワードを更新する',
    },
    Errors: {
      createReportFailed: 'レポートの作成に失敗しました。',
    },
    ReportStatus: {
      CLOSED: '解決済み',
      INVESTIGATING: '調査中',
      NEW: '提出済み',
      READ: '既読',
    },
    general: {
      navbar: {
        caseSettings: 'ケース設定',
        changePassword: 'パスワードを変更する',
        logOut: 'ログアウト',
        notifications: '通知',
        notificationsDrawer: {
          appFileScanFailed: 'ファイルがセキュリティチェックに失敗しました',
          appReportMatch: 'あなたのGoTogetherの記録が一致しました',
          appReportReassigned: '新しいケースマネージャーが割り当てられました',
          case: 'ケース',
          caseAssigned: 'あなたに割り当てられたケース',
          caseImporterJobCompleted: {
            PartialSuccess:
              'あなたのケースのインポートはエラーと共に完了しました',
            failure: 'あなたのケースのインポートは失敗しました',
            success: 'あなたのケースのインポートは成功裏に完了しました',
          },
          caseLinked: 'ケースがリンクされました',
          caseTeamInvite: 'ケースに追加されました',
          caseUnlinked: 'ケースがリンク解除されました',
          dataSanitisation: 'レポートの詳細が更新されました',
          emptyDescription: '後で新しい通知を確認してください',
          emptyTitle: 'あなたはすべてを追いついた',
          importId: 'インポートID:',
          learnMore: 'もっと詳しく知る',
          markAllAsRead: 'すべてを既読にする',
          newMessage: '新しいメッセージ',
          newReport: '新しいレポートが届きました',
          permissionRemoved: 'ケースから除外されました',
          postSSubmissionFile: '証拠ファイルが追加されました',
          report: 'レポート',
          reportAssigned: 'あなたに割り当てられたレポート',
          reportStatusChange: 'レポートのステータスが変更されました',
          reporterAnonymised: 'あなたの詳細は匿名化されました',
          reporterReportSubmitted: {
            subtitle:
              '我々はあなたのレポートのコピーを保存することをお勧めします',
            title: '提出された報告',
          },
          mitigationPlanReminder: '軽減計画の承認が必要です',
          staleCase: '未処理のケース',
        },
        privacyStatement: 'プライバシー声明',
        reporter: {
          myReports: '私のレポート',
        },
        settings: '設定',
        technicalSupport: 'テクニカルサポート',
        title: 'アカウント',
      },
      time: {
        day: '日',
        days: '日々',
        hour: '時間',
        hours: '時間',
        minute: '分',
        minutes: '分\n',
        second: '二番目',
        seconds: '秒',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: '匿名',
        autoTranslate: '自動翻訳はデフォルトではオフになっています。',
        backToMessages: 'メッセージに戻る',
        caseSettings: 'ケース設定。',
        changeInProfile:
          'この設定を変更したい場合は、プロフィールで行うことができます。',
        deletedByMessage: '{{author}} によって削除されました',
        deletedMessageLabel: 'このメッセージは削除されました',
        description:
          '自動翻訳がオンになっている場合、すべてのレポートメッセージは、ブラウザーで選択されたデフォルト言語に基づいてAIを使用して自動的に翻訳されます。',
        descriptionSecondHalf:
          'すべてのメッセージの元のバージョンは常に保存され、チャットで見つけることができます。',
        messagePlaceholder: '入力を開始してください...',
        messageSettings: 'メッセージ設定。',
        originalMessages: 'オリジナル',
        showMoreBanner: '自動翻訳についてもっと学びましょう',
        titlev2: 'あなたの好きな言語で全てのメッセージを読んでください。',
        translatedMessageLabel: '翻訳されたメッセージ',
        translatedMessages: '翻訳済み',
        understood: '了解しました',
      },
      Country: {
        description: 'どの国でご勤務されていますか？',
        header: 'どの国でご勤務されていますか？',
        noOptions: '国が見つかりません',
        other: 'その他',
        placeholder: '国を検索...',
      },
      CreatePublicReport: {
        createReport: 'レポート新規作成',
        helpPage: 'ヘルプページにアクセスしてください',
        loginToOpr: 'レポートの追跡にログインしてください',
        or: 'または',
        passwordPlaceholder: 'パスワード入力',
        phoneNumberLoginFailed:
          'ログインに失敗しました、電話番号/ピンが間違っています',
        phoneNumberPlaceholder: 'あなたの電話番号を入力してください',
        phoneNumberTooltip:
          'VaultTalkに連絡するために使用した電話番号を入力してください。',
        pinPlaceholder: 'PINを入力してください',
        reportIntroductionParagraph1:
          'インシデントを報告する際には、あなたの経験を文書化するためのサポートとしていくつかの質問がされます。',
        reportIntroductionParagraph2:
          '提出する前に、プライバシーを保護するために匿名であることを選択することができます。',
        reportIntroductionParagraph3:
          '提出後は、いつでもログインしてレポートの進行状況を確認し、ケースマネージャーと話すことができます。',
        reportIssue: '問題を報告する',
        usernameLoginFailed:
          'ログインに失敗しました、ユーザー名/パスワードが間違っています',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired: '企業との関係性が必要です',
            reportedCategoryRequired: '報告されたカテゴリーが必要です',
          },
        },
        vaultId: 'Vault ID',
        vaultIdPlaceholder:
          'あなたのメールアドレスまたはVault IDを入力してください。',
        vaultIdTooltip:
          '匿名のレポートの場合、Vault IDは英数字です。レポートが匿名ではない場合、Vault IDはあなたのメールアドレスです。',
        vaultTalk: 'VaultTalk',
        yourPassword: 'あなたのパスワード',
        yourPhoneNumber: 'あなたの電話番号',
        yourPin: 'あなたの6桁のピン',
        yourVaultId: 'あなたのVault ID',
      },
      CustomHeader: {
        companyLogo: '会社ロゴ',
        openReporting: '処理中レポート',
        userSettings: 'ユーザー設定',
      },
      Date: {
        approximateDescription:
          'そのイベントが発生した大まかな日付を覚えていますか？',
        approximatePlaceholder: '例: 6ヶ月前 / 昨年 / 昨年の11月',
        cancel: 'キャンセル',
        clear: 'クリア',
        description: 'それが発生した日付を覚えていますか？',
        header: 'それはいつ発生しましたか？',
        ok: 'OK',
        placeholder: '例: 2020年6月21日',
      },
      Description: {
        whatHappened: '何が起きましたか？',
        whatHappenedPlaceholder: '自分の言葉で...',
        whatHappenedText:
          'あなた自身の言葉で、何が起こったのかを説明してください',
      },
      Details: {
        disclaimer:
          'これらの詳細はあなたのレポートと共に公開されます。匿名を希望する場合は、特定の情報が含まれていないことを確認してください。',
        emailPlaceholder: 'メールアドレス（任意）',
        fullNamePlaceholder: '氏名（任意）',
        header: 'あなたについて',
        nonAnonSubtitle:
          'あなたの名前かメールアドレスを提供してください。このレポートに関する通知を受け取りたい場合は、下記に適切なメールアドレスを追加してください。',
        nonOptionalEmailPlaceholder: 'メール',
        nonOptionalFullNamePlaceholder: 'フルネーム',
        subtitle:
          'このレポートに関する通知を受け取りたい場合は、以下に適切なメールアドレスを追加してください。',
      },
      Emotion: {
        description: 'どのように感じましたか？どのような影響を受けましたか？',
        header: 'どのような影響を受けましたか？',
        placeholder: '入力してください...',
      },
      Evidence: {
        addedHeading: '追加されました',
        deletedMessage: 'は削除されました',
        deletedStatus: '削除されました',
        failedToOpenFileMessage:
          'ファイルを開くのに失敗しました。もう一度お試しください。',
        fileStatuses: {
          infectedUpload: 'セキュリティチェックでフラグが立てられました',
          passedUpload: 'セキュリティチェックに合格しました',
          pendingUpload: 'セキュリティチェック進行中',
          readyForDownload: 'ダウンロードの準備ができました',
        },
        mobileErrorMessage:
          'フラグ付きファイル：ケースマネージャーにメッセージを送信してください',
        nameHeading: '名前',
        statusHeading: 'ステータス',
        tableTitle: '証拠',
        webErrorMessage:
          'フラグ付きファイル：あなたのファイルがフラグ付けされている場合は、ケースマネージャーにメッセージを送ってください。',
      },
      FileUpload: {
        addFiles: 'ファイルを追加する',
        addMoreFiles: 'もっとファイルを追加してください',
        confirm: '確認する',
        description:
          '証拠としてファイルを追加することは、ケースマネージャーによる解決の効率を支援するのに役立ちます。匿名を希望する場合は、ファイルの内容（ファイルのメタデータを含む）を考慮してください、そして他の個人の権利と適用法を尊重してください。',
        dragDrop: 'ここにファイルをドロップするか、または',
        errorMessage:
          'ファイルがネットワークエラーのために失敗しました。以下をクリックしてケースマネージャーにメッセージを送り、支援を求めてください。',
        fileLimit: '各ファイルのサイズ制限：100MB',
        fileUploadLimitText: 'あなたは最大10ファイルしかアップロードできません',
        header: '証拠を追加する',
        helpArticle: 'ヘルプ記事',
        highlighted: 'ファイルを閲覧する',
        information: 'サポートされているファイルタイプ',
        moreInformation:
          '詳細については、こちらをご覧ください。 <a>ヘルプ記事</a>',
        postSubmissionErrorMessage:
          'システムエラーのため、あなたのファイルをアップロードできませんでした。もう一度「確認」を選択してください。',
        tooltipAudio: 'オーディオ:',
        tooltipAudioOptions: '.ogg、.wav、.wma',
        tooltipDocuments: 'ドキュメント:',
        tooltipDocumentsOptions: '.ps、.docx、.pptx、.xlsx、.dcm、.pdf',
        tooltipImage: '画像:',
        tooltipImageOptions:
          '.png、.apng、.jpg、.jpeg、.pjpeg、.svg、.gif、.tiff、.tif、.bmp、.psd、.avif',
        tooltipText: 'テキスト:',
        tooltipTextOptions: '.txt、.csv、.html、.xml',
        tooltipVideo: 'ビデオ:',
        tooltipVideoOptions: '.mp4、.mov、.mp1s、.asf',
        uploadErrors: {
          invalidFileSize: 'ファイルが大きすぎます',
          invalidFileType: 'サポートされていないファイルタイプ：{{extension}}',
          systemError: 'システムエラー',
          tooManyFiles: 'ファイルの最大数は {{maxFiles}} です',
        },
        uploadFiles: 'ファイルをアップロードする',
      },
      Loading: {
        loading:
          'あなたのレポートをケースマネージャーに提出する間お待ちください...',
        postSubmissionLoading:
          'あなたのファイルを送信する間、お待ちください...',
      },
      Location: {
        description: 'どこで起きましたか？',
        header: 'どこで起きましたか？',
        placeholder: '例: オフィスで',
      },
      MessageListBox: {
        messageCaseManager: 'ケースマネージャーへのメッセージ',
        report: '報告{{displayReportId}} {{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: '翻訳無効',
        enableTranslationLabelEnabled: '翻訳が有効化されました',
        enableTranslationsDescription:
          '自動翻訳を有効にし、好みの言語で全てのレポートメッセージを読んでください。翻訳される言語は、あなたのデバイスで選択された言語に基づいています。',
        enableTranslationsHeader: 'レポートメッセージの自動翻訳を有効にする',
        enableTranslationsSubDescriptionv2:
          '各チャットでは、翻訳した言語と元の言語を切り替えることができます。',
        updateTranslationFailed: '翻訳の更新に失敗しました',
        updateTranslationSuccess: '翻訳設定が正常に更新されました',
      },
      Password: {
        changePasswordHeader: 'パスワード変更',
        createNewPassword: '新しいパスワードを作成してください',
        createPasswordHeader: 'あなたのパスワード',
        currentPasswordPlaceholder: '現在のパスワード',
        description:
          '有効なパスワードは9文字以上で、大文字および数字を1つ以上含める必要があります',
        enterCurrentPassword: '現在のパスワードを入力してください',
        forgottenPasswordInstructions:
          'あなたの英数字のVault ID（メールアドレスではありません）とメールアドレスを入力してパスワードをリセットしてください。',
        newDescription:
          'あなたのアカウントを安全に保つために強力なパスワードを作成してください。下のガイドラインを見るには入力を始めてください。',
        passwordPlaceholder: 'パスワードの作成',
        passwordResetRequestedDescription:
          'あなたのVault IDが我々のシステムに存在する場合、パスワードをリセットするための指示を含むメールが届きます。',
        passwordResetRequestedHeader:
          'パスワードリセットリンクが要求されました',
        reenterPlaceholder: 'パスワードを再入力してください',
        subtitle:
          'このレポートを提出し、後からアクセスできるようにするためのパスワードを作成してください',
        yourVaultId: 'あなたのVault ID',
        yourVaultIdPlaceholder:
          'あなたのVault IDを入力してください（例. {{exampleId}}）',
      },
      Perpetrators: {
        description:
          '報告するのは特定の人または複数の人ですか？名前は分かりますか？その人物について説明してください。',
        header: '関与する人々',
        placeholder:
          '名前を入力してください。複数の場合は、名前または説明をコンマで区切ってください。',
      },
      PoweredByVault: '{{company}}提供',
      PrivacyStatement: '製品のプライバシーに関する声明',
      PublicMessageList: {
        myMessages: 'メッセージ',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader: '既存のレポートに追加された証拠',
        backToReportId: '戻るとレポートID：{{reportId}}',
        description:
          '証拠としてファイルを追加することは、ケースマネージャーによる解決の効率を支援することができます。匿名を希望する場合は、ファイルの内容（ファイルのメタデータを含む）を考慮し、他の個々の権利と適用法を尊重してください。詳細については、これをご覧ください。 <a>ヘルプ記事</a>',
        header: 'レポートに追加の証拠を追加してください',
        vaultTalkOpenCaseHeader: 'あなたの報告書に証拠を追加してください',
      },
      PublicReport: {
        anonymous: '匿名',
        backToReports: 'レポートに戻る',
        skipped: 'スキップしました',
      },
      PublicReportCard: {
        addEvidence: '追加の証拠を追加してください',
        messageCaseManager: 'ケースマネージャーへのメッセージ',
        reportId: 'レポート ID:',
        submitted: '提出済み',
        vaultTalkClosedCaseCTA: '証拠を見る',
        vaultTalkOpenCaseCTA: '証拠を追加する',
        viewAdditionalEvidence: '追加の証拠を表示する',
        viewReport: 'レポートを見る',
      },
      PublicReportsList: {
        reportingSystem: 'レポートシステム',
      },
      Question: {
        placeholder: '入力を開始してください...',
        question: '詳細を提供してください',
        questionText:
          'あなたの懸念、更新、または問い合わせを私たちと共有してください。',
      },
      Relationship: {
        header: 'あなたと組織の関係',
        tellUsAbout: 'あなたと組織の関係を教えてください。',
      },
      ResponsiveNavMenu: {
        messages: '私のメッセージ',
        reports: '私のレポート',
      },
      Site: {
        description: 'どの拠点でご勤務されていますか？',
        header: 'どの拠点でご勤務されていますか？',
        noOptions: '拠点が見つかりません',
        other: 'その他',
        placeholder: '拠点を検索...',
      },
      SpamPuzzle: {
        dialog: '続行するには、このパズルを完成してください',
      },
      SubmissionTypes: {
        reportIssue: 'カテゴリーを選択してください',
        whatType:
          'あなたのレポートを最もよく説明するカテゴリーを選択してください',
      },
      SubmitSuccess: {
        category: '<bold>カテゴリ：</bold> {{category}}',
        country: '<bold>国:</bold> {{country}}',
        dateSubmitted: '<bold>提出日:</bold> {{date}}',
        recordYourVaultID: 'この情報をログイン用に覚えておいてください',
        successInformation: '詳細情報',
        successMessage:
          'あなたのレポートは提出され、レビューの準備ができています。 注意が必要な添付ファイルはログイン時にフラグが立てられます。 下記からログインしてレポートの更新を確認し、ケースマネージャーにメッセージを送信してください。',
        successSanitationMessage:
          'あなたの記録のためにコピーを保存し、Vault-IDを安全に保管してください - それはアップデートにアクセスし、ケースマネージャーにメッセージを送るために必要になります。',
        successSanitationTagline:
          'あなたのレポートは提出され、安全に保管されました。',
        successThankYou: 'あなたの報告、ありがとうございました！',
        viewReport: 'レポートを表示',
      },
      Time: {
        approximateDescription:
          'そのイベントが発生した大まかな時刻を覚えていますか？',
        approximatePlaceholder: '例: 午前、午後',
        description: 'それが発生した時刻を覚えていますか？',
        header: 'それは何時に発生しましたか？',
        invalidTime: '時間は HH:MM で入力してください',
      },
      UserSettingsDialog: {
        changePassword: 'パスワード変更',
        closeDialog: '対話を閉じる',
        logout: 'ログアウト',
        messageSettings: 'メッセージ設定',
        userSettings: 'ユーザー設定',
      },
      Witnesses: {
        description:
          'あなたは他の誰かに言いましたか？または、他に目撃した人はいますか？',
        header: '証人はいますか？',
        placeholder: '入力してください...',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'メッセージを送る',
        title: 'メッセージケースマネージャー',
        translationHeader: '自動翻訳についてもっと学びましょう',
      },
      ReportCard: {
        addEvidence: '証拠を追加する',
        submissionModeVia: '{{submissionMode}}を介して',
        viewEvidence: '証拠を見る',
      },
      ReportList: {
        yourReports: 'あなたのレポート',
      },
      ReportingActivate: {
        buttonText: '続ける',
        description:
          'あなたの組織がアカウントを登録した場合、設定を完成させるための指示が記載されたメールをお送りします。',
        emailInput: 'メール',
        header: 'あなたの仕事用メールアドレスを入力してください',
        successAccount:
          'あなたの組織があなたのアカウントを登録した場合、セットアップを完了するための指示を記載したメールを送信します。',
        successEmail:
          'すぐに表示されない場合は、数分待ってからメールの受信トレイを更新してください。',
        successHeading: 'ありがとう',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'あなたのレポートに証拠を追加してください',
        descriptionText:
          '証拠としてファイルを追加することは、ケースマネージャーによる解決の効率を支援するのに役立ちます。匿名を希望する場合は、ファイルの内容（ファイルのメタデータを含む）を考慮し、他の個人の権利と適用法を尊重してください。詳細については、この<a>ヘルプ記事</a>をご覧ください。',
        emptyMessage: '追加の証拠はアップロードされていません',
      },
      ReportingChangePassword: {
        back: 'バック',
        description:
          'アカウントを安全に保つために強力なパスワードを作成してください。タイピングを開始すると、下にガイドラインが表示されます。',
        errorToast: 'パスワードを作成できません、無効なトークンです。',
        header: 'パスワードの変更',
        incorrectCurrentPassword:
          '現在のパスワードが間違っています。確認してもう一度お試しください。',
        invalidToken: '無効なトークン',
        passwordUpdated: 'パスワードが更新されました',
        passwordUpdatedDescription:
          'あなたのパスワードは正常に更新されました。あなたのデータを保護するためのこのステップを踏んでくれて、ありがとうございます！',
        passwordUsedBefore: 'パスワードの再使用は許されません',
        passwordUsedBeforeDescription:
          'あなたの安全のため、過去6回のパスワードは再利用することができません。アカウントを安全に保つために、新しくユニークなパスワードを選んで再試行してください。',
        toastDescription:
          'あなたのパスワードは正常に更新されました。あなたのデータを安全に保つためにこのステップを踏んでいただき、ありがとうございます！',
        toastMessage: 'パスワードが更新されました',
        updatePasswordCTA: 'パスワードを更新する',
      },
      ReportingConnect: {
        cancelButton: 'キャンセル',
        connectButton: '接続する',
        disclaimer:
          'あなたのSlackアカウントをVaultアカウントに接続することで、安全でプライベートな接続が確保されます。<br /><br />接続することで、不正行為の報告や質問を直接Slack内で行うことができます。接続後も常に匿名で報告するオプションを持つことができます。あなたのプライバシーとセキュリティは、私たちの最優先事項です。',
        heading:
          'Vault Platformは、あなたの{{organisationName}} Slackアカウントへのアクセス許可を求めています',
        listHeading: 'Vaultは何ができるのでしょうか？',
        permissionIdentity: {
          extraInfo:
            'VaultはあなたのSlackユーザーのアイデンティティを閲覧する能力を持っています',
          heading: 'ユーザーの身元に関する情報を表示する',
        },
        permissionNotifications: {
          extraInfo:
            'Vaultは、提出したレポートや質問の更新に関して、あなたのSlackアカウントに通知を送ることができます。',
          heading: '通知を送ります',
        },
        permissionOverview: {
          extraInfo: 'Vaultはホームページですべての提出物の概要を表面化します',
          heading: '提出物の概要',
        },
        permissionSubmitReport: {
          extraInfo:
            'これにより、VaultがSlackから直接、あなたの組織にレポートを提出したり、質問をしたりする許可が与えられます。',
          heading: 'あなたの代わりにレポートを提出するか、質問をする',
        },
        successfulConnectionDescription:
          'あなたのVaultアカウントとSlackアカウントが今接続されました。このタブを閉じてSlackに戻ることができます。',
        successfulConnectionHeading: '正常に接続しました',
        unsuccessfulConnectionDescription:
          '何かがうまくいきませんでした。このタブを閉じて、Slackに戻って再試行してください。',
        unsuccessfulConnectionHeading: '接続に失敗しました',
      },
      ReportingForgotPassword: {
        description:
          'あなたのアカウントに関連付けられたメールアドレスを入力してください。その後、パスワードをリセットするためのリンクをお送りします。',
        heading: 'パスワードを忘れた',
        invalidTokenError: 'パスワードを作成できません、無効なトークンです。',
        passwordReuseError: 'パスワードの再利用は許可されていません',
        passwordReuseErrorDescription:
          'あなたの安全のために、過去6回のパスワードは再利用できません。アカウントを安全に保つために新しく、ユニークなパスワードを選んで再試行してください。',
        sendLink: 'リセットリンクを送信してください',
        sendLinkFailure: '何かが間違っていました',
        sendLinkFailureDescription:
          '<a>レポーターハブ</a>に戻って再試行してください。問題が続く場合は、<mailto>techsupport@vaultplatform.com</mailto>までご連絡ください。',
        sendLinkSuccess: 'パスワードリセットのリンクが送信されました',
        sendLinkSuccessDescription:
          '私たちはパスワードリセットのリンクを{{email}}に送信しました',
        updatePasswordSuccess: 'パスワードが更新されました',
        updatePasswordSuccessDescription:
          'あなたのパスワードは正常に更新されました。データを安全に保つためにこのステップを踏んでくれてありがとう！',
      },
      ReportingLogin: {
        accountFrozen: 'アカウントが凍結されています',
        accountLocked:
          'ログインが何度も誤って試行されました。そのため、アカウントは最大1時間ロックされます。この期間中、パスワードのリセットはできません。',
        accountLockedPermanently:
          'あなたのアカウントはロックされています。アクセスを再取得するにはパスワードをリセットしてください、またはさらなるヘルプのためにシステム管理者に問い合わせてください。',
        createAccountCTA: 'アカウントを登録する',
        currentPassword: '現在のパスワード',
        emailLabel: 'あなたのメール',
        forgotPassword: 'パスワードをお忘れですか？',
        loginButton: 'ログイン',
        newPasswordPlaceholder: '新しいパスワード',
        passwordFailMessage:
          'SlackのVaultアプリに戻って再試行してください。問題が続く場合は、techsupport@vaultplatform.comまでお問い合わせください。',
        passwordFailTitle: '何かが間違っていました',
        passwordLabel: 'あなたのRassword',
        passwordPlaceholder: 'パスワードを入力してください',
        passwordResetRequired: 'パスワードのリセットが必要です',
        passwordSuccessfullySetMessage:
          '新しいパスワードを使用してSlackのVaultアプリに戻り、中断したところから続けるために認証してください。',
        passwordSuccessfullySetTitle: 'パスワードが正常に設定されました',
        reenterPlaceholder: 'パスワードを再入力してください',
        title: 'レポーターハブ',
        tooltip:
          'Vaultアプリのパスワードをまだ設定していない場合は、ここから始めてください。パスワードを忘れた場合は、下の「パスワードを忘れた」リンクを使用してください。',
        usernameLoginFailed:
          'ログインに失敗しました、ユーザー名またはパスワードが間違っています',
      },
      ReportingReset: {
        failureDescription:
          'SlackのVaultアプリに戻って再試行してください。問題が続く場合は、<mailto>techsupport@vaultplatform.com</mailto>までご連絡ください。',
        failureHeading: '何かが間違っていました',
        successDescription:
          '新しいパスワードで認証して、あなたが途中で止めていた所から続けるためにSlackのVaultアプリに戻りましょう。',
        successHeading: 'パスワードの設定が成功しました',
      },
      noReports: {
        description:
          'すべての提出されたレポートがここに表示されます。レポートを提出する方法について詳しく学ぶにはVault',
        descriptionHelpArticle: 'このヘルプ記事',
        errorDescription:
          'あなたのレポートのロードに苦労しています。ページを更新してみてください。',
        errorDescriptionSecondary:
          'それが機能しない場合は、どうか私たちに連絡してください。',
        errorTitle: '⚠️ おっと、何かがおかしいです',
        title: 'まだレポートはありません',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            '自動翻訳を有効にして、好みの言語ですべての報告メッセージを読んでください。翻訳される言語は、あなたのデバイスで選択された言語に基づいています。',
          autoTranslationDescription2:
            '各チャットで翻訳言語と元の言語を切り替えることができます。',
          autoTranslationTitle: 'レポートメッセージの自動翻訳を有効にする',
          header: 'メッセージ設定',
          subHeader: 'メッセージの表示方法を設定する',
        },
        notificationSettings: {
          emailDescription:
            'あなたのレポートに重要な更新がある場合に、メール通知を受け取ります。',
          emailTitle: 'メール通知',
          header: '通知設定',
          subHeader: '通知の受け取り方を設定する',
        },
        title: '設定',
        updatedSettingsFailure: '設定の更新に失敗しました',
        updatedSettingsSuccess: '設定の更新が成功しました',
      },
    },
    validators: {
      passwordLength: 'パスワードは9文字以上にしてください',
      passwordLowercase: 'パスワードには1つ以上の小文字が必要です',
      passwordMissMatch:
        'パスワードと確認用パスワードが一致する必要があります。',
      passwordNumeric: 'パスワードには1つ以上の数字が必要です',
      passwordUppercase: 'パスワードには1つ以上の大文字が必要です',
    },
    validatorsNew: {
      passwordLength: '10から30文字の間',
      passwordLowercase: '少なくとも一つの小文字のアルファベット',
      passwordMissMatch: 'パスワードが一致しません',
      passwordNumeric: '少なくとも一つの数字',
      passwordSpecialCharacter: '少なくとも一つの特殊文字',
      passwordUppercase: '少なくとも一つの大文字の字',
    },
  },
};

export default translations;
